import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
export const timeEntriesDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.exportTimeEntries',
        popover: {
          title: 'Export Time Reporting',
          description:
            'Use this feature to export all recorded time entries. This is useful for reporting, billing, or analyzing the time spent on various tasks.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.worklogMainTable',
        popover: {
          title: 'Worklog Overview',
          description:
            'This table displays a comprehensive overview of all worklogs. You can view, edit, and manage time entries to ensure accurate tracking.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.worklogTicketsMainTable',
        popover: {
          title: 'Ticket Worklog Table',
          description:
            'View detailed worklogs associated with specific tickets. This helps in tracking the time spent on individual tasks and ensures accurate billing or reporting.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};
export default timeEntriesDriverObj;
